import { useEffect, type RefObject } from 'react';

/**
 * Scrolls the {@link MessageList} end sentinel into view when `when` updates
 * (e.g. the displayed messages array). Used on the dashboard home feed where
 * the composer sits in a fixed footer.
 */
export function useScrollMessageListToEnd(
  messagesEndRef: RefObject<HTMLDivElement | null>,
  when: unknown,
): void {
  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messagesEndRef, when]);
}
